export const headers = [
  { name: 'Nome da agência', field: 'name', sortable: true },
  {
    name: 'Tipo de parceria',
    field: 'partnership_type',
    sortable: true,
    custom: true
  },
  { name: 'Promotor', field: 'promoter.name', sortable: true },
  { name: 'Rota', field: 'routes', sortable: true, custom: true },
  { name: 'Whatsapp', field: 'whatsapp_number', sortable: false },
  { name: 'Ações', field: 'actions', sortable: false }
]
